import React from 'react';

type ProfilePageKey = 'about' | 'news' | 'working-at';

interface SchemaEntry {
  html: string;
  show: string;
}

type ProfilePage = Record<string, boolean | string | undefined>;

interface Profile {
  page?: ProfilePage;
}

interface DescriptionParameters {
  profilePage?: ProfilePageKey;
}

const schema: Record<ProfilePageKey, SchemaEntry> = {
  about: {
    show: 'showAboutPage',
    html: 'aboutPageHtml',
  },
  'working-at': {
    show: 'showWorkingAtPage',
    html: 'workingAtPageHtml',
  },
  news: {
    show: 'showNewsPage',
    html: 'newsPageHtml',
  },
};

const getDescriptionText = (
  profile: Profile | null | undefined,
  parameters: DescriptionParameters,
) => {
  const { profilePage } = parameters;
  if (!profilePage) return false;

  const key = schema[profilePage];
  const page = { ...profile?.page };

  return page[key.show] && (
    <div
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: page[key.html] as string }}
    />
  );
};

export default getDescriptionText;
